export default __webpack_public_path__ + "static/media/hotel_soon.1eafba87.webp";